import React, { useEffect, useState } from "react";
import MarqueeText from "../../MarqueeText/MarqueeText";
// import SVLS_API from "../../../api/api-services/svls-api";
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
  checkIncludeMultiMarket,
  CURRENCY_TYPE_FACTOR,
  EventDTO,
  MarketNotification,
  useAppDispatch,
  getCurrencyTypeFromToken,
  UserBet,
  useAppSelector,
  addToMultiMarket,
  removeToMultiMarket,
  showToast,
  langData,
  setLoading,
  setAlertMsg,
  PlaceBetRequest,
  isBackOnlyMarket,
  isBmSpecialMarket,
} from "@hypexone/uicore";
import {
  IMultiMarket,
  useMarketLocalState,
} from "../../../../utils/hooks/storage.hooks";
import MarketTableHeading from "../market-table/MarketTableHeading";
import BookmakerRow from "./BookmakerRow";
import { isMobile } from "react-device-detect";
import Modal from "../../shared/ModalComponent";
import PinIconGray from "../../../../assets/icons/events-icons/pin-icon-gray.svg";
import PinIconGreen from "../../../../assets/icons/events-icons/pin-icon-green.svg";
import InfoIconRoundedWhite from "../../../../assets/icons/info-icon-rounded-white.svg";
import Button from "../../shared/Button/Button";
import { colors } from "../../../../styles/colors";
import { BRAND_DOMAIN } from "../../../../constants/Branding";
import { API_CLIENT } from "../../../../App.utils";
import OneClickBettingCountdown from "../../one-click-betting/OneClickBettingCountdown";
import { FaStar } from "react-icons/fa";

export interface OddsInfoMsg {
  launch: boolean;
  oddsType: string | null;
  eventTypeID: string | null;
}

interface BMProps {
  eventData: EventDTO;
  bmData: BookmakerDTO[];
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
  isMultiMarket?: boolean;
  exposureMap: any;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  marketNotifications: any;
  loading: boolean;
}

// const multiPinsMap = {
//   purple: RemoveMultiPin,
//   darkvoilet: RemoveMultiPinDarkViolet,
//   darkgreen: RemoveMultiPinDarkGreen,
// };

const Bookmaker: React.FC<BMProps> = ({
  eventData,
  bmData,
  setAddNewBet,
  setBetStartTime,
  isMultiMarket,
  loggedIn,
  exposureMap,
  marketNotifications,
  loading,
}) => {
  const { bets, openBets, isOneClickBettingLoading, bettingInprogress } =
    useAppSelector((state) => state.betSlip);
  const { domainConfig } = useAppSelector((state) => state.common);
  const cashoutEnabled = useAppSelector((state) => state.common.domainConfig?.cashoutEnabled === true);
  const incentiveEnabled = !!(domainConfig as any)?.incentive_enabled;
  const [notifications, setNotifications] = useState<Map<String, string>>(
    new Map()
  );
  const [openBetsMap, setOpenBetsMap] = useState<Map<String, UserBet[]>>(
    new Map()
  );
  const [isPopupVisible, setPopupVisible] = useState(false);
  const dispatch = useAppDispatch();
  const [confirmCashout, setConfirmCashout] = useState<boolean>(false);
  const eventCashoutEnabled =
    (eventData as EventDTO & { cashoutEnabled?: boolean })?.cashoutEnabled !==
    false;
  useEffect(() => {
    if (!eventCashoutEnabled && confirmCashout) {
      setConfirmCashout(false);
    }
  }, [eventCashoutEnabled, confirmCashout]);
  const [isCashoutProcessing, setIsCashoutProcessing] = useState<boolean>(false);
  const [coMarket, setCoMarket] = useState<BookmakerDTO>(null);
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const disabledStatus = [
    "suspended",
    "closed",
    "suspended-manually",
    "ball_running",
  ];

  // Cash-out calculation functions
  const getHighAndLowRiskRunners = (runners) => {
    let highRiskRunner = runners[0]?.runnerId;
    let lowRiskRunner = runners[1]?.runnerId;

    if (runners[1]?.userRisk < runners[0]?.userRisk) {
      [highRiskRunner, lowRiskRunner] = [lowRiskRunner, highRiskRunner];
    }

    return { highRiskRunner, lowRiskRunner };
  };

  const getOdds = (highRiskRunner, lowRiskRunner, runners) => {
    if (!bmData) return {};

    let odds = {
      highRiskBackPrice: 0,
      highRiskLayPrice: 0,
      lowRiskBackPrice: 0,
      lowRiskLayPrice: 0,
    };

    runners.forEach((runner) => {
      if (runner.runnerId === highRiskRunner) {
        odds.highRiskBackPrice = ((runner?.backPrice || 0) + 100) / 100;
        odds.highRiskLayPrice = ((runner?.layPrice || 0) + 100) / 100;
      }
      if (runner.runnerId === lowRiskRunner) {
        odds.lowRiskBackPrice = ((runner?.backPrice || 0) + 100) / 100;
        odds.lowRiskLayPrice = ((runner?.layPrice || 0) + 100) / 100;
      }
    });

    return odds;
  };

  const getFavRunner = (riskRunners, odds) => {
    const { highRiskRunner, lowRiskRunner } = riskRunners;
    const {
      highRiskBackPrice,
      lowRiskBackPrice,
      highRiskLayPrice,
      lowRiskLayPrice,
    } = odds;

    if (highRiskBackPrice > 1.0 && lowRiskBackPrice > 1.0) {
      return lowRiskBackPrice < highRiskBackPrice
        ? lowRiskRunner
        : highRiskRunner;
    }
    if (
      (highRiskBackPrice > 1.0 && highRiskBackPrice < 2.0) ||
      highRiskLayPrice >= 2.0
    ) {
      return highRiskRunner;
    }
    if (
      (lowRiskBackPrice > 1.0 && lowRiskBackPrice < 2.0) ||
      lowRiskLayPrice >= 2.0
    ) {
      return lowRiskRunner;
    }

    return highRiskRunner; // Default case
  };

  const getPayoutMap = (runners, key) => {
    const payoutMap = new Map();

    runners.forEach((runner) => {
      const runnerId = runner?.runnerId;

      openBetsMap.get(key)?.forEach((bet) => {
        const outcomeMatch = runnerId === bet.outcomeId;
        const betTypeBack = bet.betType === "BACK";
        const payout = bet.oddValue * bet.stakeAmount;

        if ((outcomeMatch && betTypeBack) || (!outcomeMatch && !betTypeBack)) {
          payoutMap.set(runnerId, (payoutMap.get(runnerId) || 0) + payout);
        }
      });
    });

    return payoutMap;
  };

  const getResponse = (riskRunners, favRunner, odds, payoutDiff) => {
    const isBackBet = riskRunners?.highRiskRunner === favRunner;
    const runnerId = isBackBet
      ? riskRunners?.highRiskRunner
      : riskRunners?.lowRiskRunner;
    const betType = isBackBet ? "BACK" : "LAY";
    const oddValue = isBackBet
      ? odds?.highRiskBackPrice
      : odds?.lowRiskLayPrice;
    let stake = Math.round((payoutDiff / oddValue) * 100) / 100;
    return { runnerId, betType, oddValue, stake, profit: Infinity };
  };

  const calCashout = (market: BookmakerDTO) => {
    // Proceed only for markets with 2 runners
    const key = `${market.marketId}:${market.marketName}`;

    const risk = exposureMap[key];
    if (!risk) {
      return {
        runnerId: "",
        betType: "",
        oddValue: 0,
        stake: 0,
        profit: Infinity,
      };
    }
    // Retrieve high and low-risk runners
    const riskRunners = getHighAndLowRiskRunners(risk);

    // Calculate payout differences
    const payoutMap = getPayoutMap(risk, key);

    // Get odds for high and low-risk runners
    const odds = getOdds(
      riskRunners?.highRiskRunner,
      riskRunners?.lowRiskRunner,
      market.runners
    );

    // Determine the favorite runner
    const favRunner = getFavRunner(riskRunners, odds);

    // Calculate payout difference
    const payoutDiff =
      (payoutMap.get(riskRunners?.lowRiskRunner) || 0) -
      (payoutMap.get(riskRunners?.highRiskRunner) || 0);

    let response = getResponse(riskRunners, favRunner, odds, payoutDiff);
    for (let rn of risk) {
      if (rn.runnerId != response.runnerId && response.stake != 0) {
        let profit = +(response.stake - Math.abs(rn?.userRisk));
        if (response.betType === "BACK") {
          profit = -1 * profit;
        }
        response = { ...response, profit: +(profit / cFactor).toFixed(2) };
      }
    }

    // Determine the cash-out response
    return response;
  };

  const getCashoutProfit = (market: BookmakerDTO) => {
    // Proceed only for markets with 2 runners
    if (market?.runners?.length !== 2) return 0;

    const key = `${market.marketId}:${market.marketName}`;

    if (!openBetsMap.has(key) || openBetsMap.get(key).length == 0) return 0;

    const response = calCashout(market);

    return response.profit || 0;
  };

  const autoCashout = async () => {
    if (coMarket == null || !eventCashoutEnabled) return;
    setIsCashoutProcessing(true);
    const response = calCashout(coMarket);

    if (response.oddValue == 0) {
      setIsCashoutProcessing(false);
      return;
    }

    const payload = {
      sportId: eventData.sportId,
      seriesId: eventData.competitionId,
      seriesName: eventData.competitionName,
      eventId: eventData.eventId,
      eventName: eventData.eventName,
      eventDate: eventData.openDate,
      marketId: coMarket.marketId,
      marketName: coMarket.marketName,
      marketType: "BM",
      outcomeId: response.runnerId,
      betType: response.betType,
      oddValue: +(+response.oddValue * 100 - 100).toFixed(2),
      amount: +(response.stake / cFactor).toFixed(2),
      outcomeDesc: getOutcomeId(response.runnerId, coMarket.runners),
      sessionPrice: -1,
      srEventId: eventData.eventId,
      srSeriesId: eventData.competitionId,
      srSportId: eventData.sportId,
      oddLimt: coMarket?.marketLimits?.maxOdd.toString(),
      mcategory: "ALL",
    };

    if (payload.amount < 100) {
      setAlertMsg({
        type: "error",
        message: langData?.["minimum_stake_txt"] + " " + 100 + ".",
      });
      dispatch(setLoading(true));
      setIsCashoutProcessing(false);
      return;
    } else if (payload.amount > coMarket?.marketLimits?.maxStake) {
      setAlertMsg({
        type: "error",
        message:
          (langData?.["maximum_stake_amount"] || "Your bet amount") +
          " " +
          payload.amount +
          " " +
          (langData?.["max_stakeamount"] || "exceeds max stake amount") +
          " " +
          coMarket?.marketLimits?.maxStake +
          ".",
      });
      dispatch(setLoading(false));
      setIsCashoutProcessing(false);
      return;
    }

    try {
      const response = await API_CLIENT.post(
        `/bs/place-bookmaker-bet`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem("jwt_token"),
          },
          timeout: 1000 * 20,
        }
      );

      if (response.status === 200) {
      }
    } catch (error) {
      setAlertMsg({
        type: "error",
        message: error?.response?.data?.message,
      });
    }
    dispatch(setLoading(false));
    setIsCashoutProcessing(false);
  };

  const handleMultiMarket = (
    competitionId: string,
    eventId: string,
    marketId: string,
    providerName: string,
    sportId: string,
    isAdd: boolean
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState: IMultiMarket[]) => [
            ...prevState,
            { competitionId, eventId, marketId, providerName, sportId },
          ]);
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            const data = [...prevState];
            const index = data.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            if (index > -1) data.splice(index, 1);
            return data;
          });
      }
    } else {
      dispatch(
        showToast({
          type: "error",
          message: "Please login",
        })
      );
    }
  };

  const openPopup = () => setPopupVisible(true);
  const closePopup = () => setPopupVisible(false);

  useEffect(() => {
    let boMap = new Map();
    openBets
      .filter((b) => b.marketType == "BOOKMAKER")
      .forEach((bet) => {
        const key = `${bet.marketId}:${bet.marketName}`;
        if (boMap.has(key)) {
          let boBets: UserBet[] = boMap.get(key);
          boBets.push(bet);
          boMap.set(key, boBets);
        } else {
          boMap.set(key, [bet]);
        }
      });
    setOpenBetsMap(boMap);
  }, [openBets]);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const getOutcomeId = (selectionId: string, runners: BookmakerRunnerDTO[]) => {
    for (let mo of runners) {
      if (mo.runnerId === selectionId) {
        return mo.runnerName;
      }
    }
  };

  const isHaveCashOut = (bmMarket: BookmakerDTO) => {
    if (bmMarket?.runners?.length !== 2) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (marketNotifications) {
      const map = new Map();
      marketNotifications.forEach((msgObj) => {
        map.set(msgObj.marketId, msgObj.message);
      });
      setNotifications(map);
    }
  }, [marketNotifications]);

  const rules = [
    "advantage_or_disadvantage_for_team_txt",
    "suspend_or_void_rights",
    "compare_teams_25_overs",
    "compare_teams_10_overs",
    "contacted_within_7_days",
    "end_two_teams_with_equal_points",
    "tennis_advance_fancy_market",
    "all_bets_will_be_voided",
    "market_will_be_settled_as_three_sets",
    "virtual_cricket",
    "technical_issues_bookmaker_market_will_be_voided",
  ];
  const highLightedIndices = [0, 1, 2, 3, 4, 5, 6, 9];

  return (
    <div className="flex flex-col  rounded-md border border-solid border-neutral-200 max-md:max-w-full">
      {bmData?.map((market, index) => {
        const backOnly = isBmSpecialMarket(market.marketName, market.oddType);

        return (
          <React.Fragment key={index}>
          {!isMultiMarket ||
          checkIncludeMultiMarket(multiMarketData, market.marketId) ? (
            <>
              <div className="relative mb-[1rem]">
                {((isOneClickBettingLoading || bettingInprogress) &&
                  bets?.[0]?.marketName === market?.marketName &&
                  bets?.[0]?.marketId === market?.marketId &&
                  bets?.[0]?.marketType === "BM") ||
                  (isCashoutProcessing && coMarket?.marketId === market?.marketId) ? (
                     <OneClickBettingCountdown
                      delay={market?.marketLimits?.delay || 0}
                    />
                  ) : null}
                    
                <div className="flex items-center justify-between w-full bg-blue4 px-4 py-2 text-xs text-white font-bold">
                  <div className="flex items-center">
                    {!checkIncludeMultiMarket(
                      multiMarketData,
                      market.marketId
                    ) ? (
                      <span title="Add To Multi Markets">
                        <img
                          src={PinIconGray}
                          alt="multipin"
                          className="multi-add-icon cursor-pointer max-h-[22px]"
                          onClick={(e) => {
                            e.stopPropagation();
                            multiMarketData?.length < 10 &&
                              handleMultiMarket(
                                eventData?.competitionId,
                                eventData?.eventId,
                                market.marketId,
                                eventData?.providerName,
                                eventData?.sportId,
                                true
                              );
                          }}
                        />
                      </span>
                    ) : (
                      <span title="Remove From Multi Markets">
                        <img
                          src={PinIconGreen}
                          alt="multipin"
                          className="multi-remove-icon cursor-pointer max-h-[22px]"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMultiMarket(
                              eventData?.competitionId,
                              eventData?.eventId,
                              market.marketId,
                              eventData?.providerName,
                              eventData?.sportId,
                              false
                            );
                          }}
                        />
                      </span>
                    )}

                    <div className="ml-2 flex items-center">
                      <div>
                        {market?.marketName?.toUpperCase()}
                        {incentiveEnabled && market?.commissionEnabled ? (
                          <FaStar className="commission-star" />
                        ) : null}
                      </div>
                      {cashoutEnabled && eventCashoutEnabled && (
                      <Button
                        className={`px-2 tracking-tighter text-black leading-normal relative overflow-hidden text-[10px] ml-1 transition duration-150 ease-in-out bg-[yellow] rounded-md text-center shadow-[inset_-12px_-8px_40px_#46464620] flex items-center justify-center flex-row h-fit py-1 cursor-pointer ${
                          getCashoutProfit(market) >= 0 ? "profit" : "loss"
                        }`}
                        disabled={
                          !isHaveCashOut(market) ||
                          disabledStatus.includes(
                            market.status.toLowerCase()
                          ) ||
                          market.suspend === true ||
                          !(
                            `${market?.marketId}:${market?.marketName}` in
                            exposureMap
                          ) ||
                          getCashoutProfit(market) == Infinity
                        }
                        loading={loading}
                        onClick={() => {
                          setCoMarket(market);
                          setConfirmCashout(true);
                        }}
                      >
                        {langData?.["cashout"].toUpperCase()}{" "}
                        {getCashoutProfit(market) != Infinity
                          ? `: ₹${getCashoutProfit(market)}`
                          : ""}
                      </Button>
                      )}
                      <div className="ml-4 cursor-pointer">
                        <img
                          onClick={openPopup}
                          src={InfoIconRoundedWhite}
                          alt="info-icon"
                          className="h-[13px] w-[13px] min-w-[13px]"
                        />
                      </div>
                    </div>
                    <span>
                      {isMultiMarket && !isMobile && (
                        <span className="pl-2">{eventData?.eventName}</span>
                      )}
                    </span>
                  </div>
                  <Modal
                    isOpen={isPopupVisible}
                    onClose={closePopup}
                    content={<div>Popup Content</div>}
                    title="Rules"
                  >
                    {rules.map((point, index) => (
                      <div
                        key={index}
                        className={`p-[8px] border-b font-sans font-[450] border-gray-300 flex items-center text-[12px]  ${
                          highLightedIndices.includes(index)
                            ? "text-[#F1556C]"
                            : " text-[#000]"
                        }`}
                      >
                        {langData?.[point] || point}
                      </div>
                    ))}
                  </Modal>
                </div>

                <table className="w-full text-[14px] font-medium text-black bg-yellow1 ">
                  <MarketTableHeading
                    title1="back"
                    title2="lay"
                    minStake={market.marketLimits?.minStake || 0}
                    maxStake={market.marketLimits?.maxStake || 0}
                    hideLay={backOnly}
                  />
                  <tbody>
                    {market?.runners
                        ?.filter((bmSelection) => {
                          if (market.marketName === "Genie Combo Special Bet") {
                            return bmSelection.runnerName !== "No winner";
                          }
                          return true;
                        })
                        ?.map((runner, idx) => (
                      <BookmakerRow
                        key={idx}
                        exposureMap={exposureMap}
                        cFactor={cFactor}
                        runner={runner}
                        market={market}
                        eventData={eventData}
                        index={index}
                        setAddNewBet={setAddNewBet}
                        setBetStartTime={setBetStartTime}
                        hideLay={backOnly}
                      />
                    ))}

                    {notifications.get(market.marketId) ? (
                      <tr>
                        <td colSpan={12} className=" overflow-hidden">
                          <MarqueeText
                            text={`🏆 ${notifications.get(market.marketId)} 🏆`}
                          />
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </>
          ) : null}
          </React.Fragment>
        );
      })}
      <Modal
        title="Do you wish to perform cash out?"
        isOpen={confirmCashout}
        onClose={() => setConfirmCashout(false)}
      >
        {/* <div className="flex">
          <Button
            color="primary"
            className="py-2 px-4 bg-orange-700 rounded text-white "
            onClick={() => setConfirmCashout(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="py-2 px-4 ml-2 bg-green-600 rounded text-white "
            onClick={() => {
              setLoading(true);
              autoCashout();
              setConfirmCashout(false);
            }}
            disabled={loading}
          >
            {langData?.['cashout']}
          </Button>
        </div> */}
        <div className="grid grid-cols-2 w-full gap-x-2">
          {/* Cancel Button */}
          <Button
            type="button"
            onClick={() => setConfirmCashout(false)}
            className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-transparent w-full px-2.5 py-1 border-[1px] border-primary rounded-[4px] flex items-center justify-center cursor-pointer"
          >
            <span className="text-text_Primary text-[16px] font-[700] font-lato">
              cancel
            </span>
          </Button>

          {/* Cashout Button */}
          <div className="w-full">
            <Button
              type="button"
              disabled={loading}
              onClick={() => {
                setLoading(true);
                autoCashout();
                setConfirmCashout(false);
              }}
              className="leading-normal relative overflow-hidden transition duration-150 ease-in-out bg-[#29ab2b] w-full h-[36px] min-h-[36px] px-2.5 py-1 border-[1px] border-success rounded-[4px] flex items-center justify-center cursor-pointer"
            >
              <span className="text-white text-[16px] font-[700] font-lato">
                cashout
              </span>
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Bookmaker;
